import { useState, useEffect, useCallback, memo } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setBetData } from "../redux/slices/fullmarketSlice";
import {
  updateAvailableBalance,
  updateExposureBalance,
} from "../redux/slices/userSlice";
import { addBet } from "../redux/slices/accountSlice";
import { myBet } from "../api";
import Loading from "../../SkyExchangeSrc/src/components/Loading";
import { placeBet } from "../../socketClient";

const ODDS_TYPES = {
  BACK: "Back",
  LAY: "Lay",
};

const BettingSlip = memo(
  ({
    data,
    runningData,
    betData,
    index,
    matchIndex,
    matchesData,
    oddsData,
    onCancel,
    newData,
    nodelay = true,
    horseData,
    isTiedMatch = false,
    anyData,
    minmax,
    matchOddsMarketId,
    markets,
  }) => {
    const [currentOdds, setCurrentOdds] = useState(() => oddsData?.odds || 0);
    const [stake, setStake] = useState("");
    const [liveValue, setLiveValue] = useState(null);
    const [acceptAnyOdds, setAcceptAnyOdds] = useState(false);
    const [loading, setLoading] = useState(false);
    const [odsData, setOdsData] = useState([]);
    const [calculateValue, setCalculateValue] = useState(0);

    const [stakesValues, setStakesValues] = useState(() => {
      const saved = localStorage.getItem("stakes");
      return saved ? JSON.parse(saved) : [];
    });

    const filterRunners = markets?.filter((e) => {
      return e?.marketId === matchOddsMarketId;
    });
    // console.log(filterRunners[0].runners);

    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const marketId = matchOddsMarketId || searchParams.get("marketId");
    const joinedMarketIds = searchParams.get("joinedMarketIds");
    const eventId = searchParams.get("eventId");

    const [formData, setFormData] = useState({});

    const handleCheckboxChange = useCallback((e) => {
      setAcceptAnyOdds(e?.target.checked);
    }, []);

    const handleOddsChange = (increment) => {
      setCurrentOdds((prevOdds) => {
        let newOdds = prevOdds + 0.01 * increment;
        newOdds = parseFloat(newOdds?.toFixed(2));
        // if(increment===-1 && minmax && minmax.min <= newOdds && minmax.max >= newOdds){
        return newOdds;
        // }
        // if(increment===1 && minmax && minmax.max <= newOdds){
        //   return newOdds;
        // }
        // return prevOdds
      });
    };

    const handleAmountClick = useCallback((amount) => {
      setStake((prev) => String(Number(prev || 0) + Number(amount)));
    }, []);

    const handleNumPadClick = useCallback((num) => {
      setStake((prev) => prev + num);
    }, []);

    const handleCancelClick = useCallback(() => {
      setStake("");
      setCalculateValue(0);
      dispatch(
        setBetData({
          calculateValue: 0,
          addedValue: null,
          index: null,
          marketId: formData.marketId,
        })
      );
      setLoading(false);
      onCancel?.();
    }, [dispatch, onCancel]);

    const fetchBets = useCallback(async () => {
      try {
        const response = await myBet();
        dispatch(addBet(response?.data?.data?.slice().reverse() || []));
      } catch (error) {
        console.error("Error fetching bets:", error.message);
        dispatch(addBet([]));
        toast.error("Failed to fetch bets");
      }
    }, [dispatch]);

    const handleButtonClick = useCallback(async () => {
      try {
        if (minmax) {
          const { min, max, currentMatchExposure } = minmax;
          const newCurrentMatchExposure = Number(
            Number(formData.againstMargin) + Number(currentMatchExposure)
          );
          if (
            !(
              Number(newCurrentMatchExposure) <= max &&
              Number(formData.againstMargin) >= min
            )
          ) {
            toast.warning("Please check min max limits.");
            return;
          }
        }
        setLoading(true);
        const createResponse = await placeBet(formData);

        if (!createResponse.success) {
          toast.warning(createResponse.message);
          return;
        }
        toast.success(createResponse.message);
        handleCancelClick();
        dispatch(
          updateAvailableBalance(createResponse?.userData?.availableBalance)
        );
        dispatch(updateExposureBalance(createResponse?.exposure));
      } catch (error) {
        console.error("Error placing bet:", error.message);
        toast.error("Failed to place bet");
      } finally {
        setLoading(false);
      }
    }, [oddsData, liveValue, formData, fetchBets, dispatch, handleCancelClick]);

    // Optimized effect hooks
    useEffect(() => {
      setCurrentOdds(acceptAnyOdds ? liveValue : oddsData?.odds || 0);
    }, [acceptAnyOdds, liveValue, oddsData]);

    useEffect(() => {
      if (!matchesData?.data) return;

      const filteredMatches = matchesData?.data?.filter(
        (e) => e?.eventId === eventId
      );
      console.log({ filteredMatches });
      if (JSON.stringify(filteredMatches) !== JSON.stringify(odsData)) {
        setOdsData(filteredMatches);
      }
    }, [matchesData, eventId, odsData]);

    useEffect(() => {
      const matchData = odsData[0];
      console.log({ matchData });

      setFormData({
        type: oddsData?.oddsType || "",
        selection: oddsData?.runnerName || "",
        selectionId: oddsData?.selectionId || "",
        oddsReq: oddsData?.odds || "",
        eventType:
          matchData?.sportId || newData?.sportId || oddsData?.eventType || "",
        eventId:
          matchData?.eventId || newData?.eventId || oddsData?.eventId || "",
        legueId:
          matchData?.competitionId ||
          oddsData.legueId ||
          newData?.marketId ||
          oddsData?.marketId ||
          "",
        event:
          matchData?.eventName ||
          oddsData.eventName ||
          oddsData?.raceName ||
          "",
        marketId:
          filterRunners?.[0]?.marketId ||
          anyData?.marketData?.marketId ||
          matchData?.marketId ||
          newData?.marketId ||
          oddsData?.marketId ||
          "",
        joinedMarketIds:
          joinedMarketIds ||
          newData?.marketId ||
          oddsData?.joinedMarketIds ||
          "",
        matchId:
          oddsData?.matchId || matchData?.eventId || newData?.marketId || "",
        market:
          filterRunners?.[0]?.marketName ||
          anyData?.marketData?.marketName ||
          matchData?.marketName ||
          newData?.markettype ||
          oddsData?.market ||
          "",
        markettype:
          oddsData?.markettype ||
          anyData?.marketData?.marketName ||
          newData?.markettype ||
          "",
        runners:
          filterRunners?.[0].runners ||
          anyData?.marketData?.runners ||
          matchData?.matchRunners ||
          newData?.runners ||
          oddsData?.runners ||
          data?.data?.[0]?.runners ||
          "",
        sportsName:
          matchData?.sportName ||
          newData?.sportId ||
          oddsData?.sportsName ||
          oddsData?.sportName ||
          "",
        againstMargin:
          oddsData?.oddsType === ODDS_TYPES.BACK ? stake : calculateValue,
        index:
          index ||
          matchIndex ||
          data?.data?.[0]?.runners?.findIndex(
            (runner) => runner.selectionId === oddsData?.selectionId
          ) ||
          null,
        stake: stake || "",
        favourMargin:
          oddsData?.oddsType === ODDS_TYPES.LAY ? stake : calculateValue,

        placeTime: new Date().toISOString(),
        runnersCount:
          filterRunners?.[0]?.runners?.length ||
          matchData?.matchRunners?.length ||
          data?.data?.[0]?.runners?.length ||
          0,
        ...(oddsData?.question ? { question: oddsData?.question } : {}),
      });
    }, [odsData, stake, oddsData, calculateValue, matchIndex]);
    console.log({ formData });

    useEffect(() => {
      if (!data?.data || !oddsData) return;

      const runner =
        data &&
        data?.data &&
        data?.data?.length > 0 &&
        data?.data
          ?.flatMap((e) => e?.runners)
          ?.find((r) => r?.selectionId === oddsData?.selectionId);

      if (!runner) return;

      const priceField =
        oddsData?.oddsType === ODDS_TYPES?.BACK
          ? "availableToBack"
          : "availableToLay";

      const prices = runner.ex[priceField]?.filter((p) => p?.price > 0) || [];
      if (prices.length) {
        const selectedPrice = prices[Math.min(index, prices.length - 1)]?.price;
        if (selectedPrice && selectedPrice !== liveValue) {
          setLiveValue(selectedPrice);
        }
      }
    }, [data, oddsData, index, liveValue]);

    useEffect(() => {
      if (!stake || !oddsData?.odds) {
        setCalculateValue(0);
        return;
      }

      const value = Number(stake);
      const calculated = oddsData.odds * value - value;
      setCalculateValue(calculated);

      dispatch(
        setBetData({
          calculateValue: calculated,
          index: matchIndex,
          addedValue: value,
          selectionId: oddsData?.selectionId,
          type: oddsData?.oddsType,
          marketId: formData.marketId,
        })
      );
    }, [stake, oddsData, matchIndex, dispatch]);

    // useEffect(() => {
    //   return () => handleCancelClick();
    // }, []);

    useEffect(() => {
      const timer = setTimeout(() => {
        if (!loading) {
          onCancel();
        }
      }, 15000); // Auto-close after 10 seconds

      return () => clearTimeout(timer);
    }, []);

    // Render
    return (
      <>
        {loading && <Loading />}
        <div className="rounded-md">
          <div
            className={`flex items-center justify-end bet-menu-main ${
              oddsData?.oddsType === ODDS_TYPES.LAY
                ? "bg-[#f3dce2]"
                : "bg-[#BEDDF4]"
            }`}
          >
            <span className="mr-2 font-semibold text-sm hide-mobile-keybord-t">
              {oddsData?.runnerName} -{" "}
              <span className="text-sm">MATCH ODDS</span>
            </span>

            <div className="bet-menus">
              <button
                onClick={() => handleOddsChange(-1)}
                className="px-2 bg-[#d92144] text-sm bg-gray-300 rounded py-0.5"
                aria-label="Decrease odds"
              >
                -
              </button>
              <input
                type="number"
                value={acceptAnyOdds ? liveValue : currentOdds}
                onChange={(e) => setCurrentOdds(Number(e?.target.value))}
                className="w-24 text-center border border-gray-300 rounded"
                readOnly={acceptAnyOdds}
                min="0"
                step="0.1"
              />
              <button
                onClick={() => handleOddsChange(1)}
                className="bg-[#037b03] rounded px-2 text-sm py-0.5"
                aria-label="Increase odds"
              >
                +
              </button>
            </div>

            <div className="bet-menus">
              <button
                onClick={() =>
                  // handleStakeChange(-1)
                  setStake((prev) => String(Math.max(0, Number(prev) - 1)))
                }
                className="bg-[#d92144] rounded px-2 text-sm py-0.5"
                aria-label="Decrease stake"
              >
                -
              </button>
              <input
                type="number"
                value={stake}
                onChange={(e) => setStake(e?.target.value)}
                className="w-24 text-center border border-gray-300 rounded"
                min={minmax ? String(minmax.min) : "0"}
                // max={minmax ? String(minmax.max) : ""}
              />
              <button
                onClick={() =>
                  setStake((prev) => String(Number(prev || 0) + 1))
                }
                className="px-2 py-0.5 text-sm bg-[#037b03] rounded"
                aria-label="Increase stake"
              >
                +
              </button>
            </div>
          </div>

          <div
            className={`flex flex-wrap gap-2 mb-2 justify-end pt-3 ${
              oddsData?.oddsType === ODDS_TYPES.LAY
                ? "bg-[#faeff2]"
                : "bg-[#D4E8F8]"
            }`}
          >
            <div className="amout-btn-box sm:space-x-2">
              {stakesValues?.map(({ id, buttonValue }) => (
                <button
                  key={id}
                  onClick={() => handleAmountClick(buttonValue)}
                  className="p-1.5 px-4 text-white rounded text-sm"
                  style={{
                    background:
                      oddsData?.oddsType === ODDS_TYPES.LAY
                        ? "linear-gradient(#fbbcbf, #eb7c81)"
                        : "linear-gradient(#61cce6, #29a3c2)",
                  }}
                >
                  +{buttonValue}
                </button>
              ))}
            </div>

            <div className="keyboard-wrap keyboard-wrap-asian">
              <div className="btn-tel">
                {[
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8",
                  "9",
                  "0",
                  "00",
                  ".",
                ]?.map((num) => (
                  <li key={num}>
                    <button onClick={() => handleNumPadClick(num)}>
                      {num}
                    </button>
                  </li>
                ))}
              </div>
              <button
                className="btn-delete"
                onClick={() =>
                  setStake((prev) => String(prev).slice(0, -1) || "0")
                }
                aria-label="Delete last digit"
              />
            </div>

            <div className="bet-bottom-btn space-x-2">
              <button
                onClick={handleCancelClick}
                className="p-1.5 px-4 bg-[#D92144] text-white rounded text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleButtonClick}
                className="p-1.5 px-4 bg-[#037B03] text-white rounded mr-2 text-sm"
                disabled={loading}
              >
                Place Bet
              </button>
            </div>
          </div>

          <div className="bet-setting-box-asian">
            <input
              type="checkbox"
              id="acceptAnyOdds"
              name="acceptAnyOdds"
              checked={acceptAnyOdds}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="acceptAnyOdds">Accept Any Odds</label>
          </div>
        </div>
      </>
    );
  }
);

export default BettingSlip;
